<template>
  <div>
    <!-- class="b-rotate-canvas" -->
    <div class="b-canvas">
      <canvas
        class="b-rotate-canvas"
        crossorigin="anonymous"
        ref="canvas"
        @mousedown="handleMouseDown"
      ></canvas>
      <div class="b-canvas-btn-grp">
        <button
          class="b-global__button"
          @click="handleMaskImage"
        >MASK</button>
        <button
          class="b-global__button"
          @click="setCanvas"
        >RESET</button>
        <button
          class="b-global__button"
          @click="saveImg"
          :disabled="!isMasked"
        >SAVE</button>
      </div>
      <div class="b-canvas-preview">
        <h2>Preview</h2>
        <img
          :src="cropped"
          class="b-canvas-masked-image"
        >
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      isDrawing: false,
      startX: null,
      startY: null,
      cropped: null,
      isMasked: false
    };
  },
  mounted () {
    if (this.$store.state.ckycDetails.croppedImgUrl) {
      this.setCanvas();


    } else {
      this.$router.replace({
        name: "ckyc-details-id",
        params: { id: this.$route.params.id }
      });
    }


  },
  methods: {

    saveImg () {
      this.$store
        .dispatch("uploadImageCkyc", {
          image: this.cropped,
          id: this.$route.params.id,
          key: this.$route.params.imgname,
          name: `${this.$route.params.imgname}.jpeg`
        })
        .then(() => this.$router.back());
    },

    handleMouseDown (e) {
      let canvas = this.$refs.canvas;
      let ctx = canvas.getContext("2d");

      let offsetX = canvas.offsetLeft;
      let offsetY = canvas.offsetTop;
      // console.log({ offsetX: canvas.offsetLeft, offsetY: canvas.offsetTop })

      // console.log({ clientX: e.clientX, clientY: e.clientY })
      let mouseX = parseInt(e.clientX - offsetX);
      let mouseY = parseInt(e.clientY - offsetY);

      if (this.isDrawing) {

        this.isDrawing = false;
        ctx.beginPath();
        // console.log({ x1: this.startX, y1: this.startY, x2: e.clientX, y2: this.startY })
        ctx.fillRect(this.startX + window.scrollX, this.startY + window.scrollY, mouseX - this.startX, mouseY - this.startY);
        ctx.fill();
        canvas.style.cursor = "default";
      } else {

        this.isDrawing = true;
        this.startX = mouseX;
        this.startY = mouseY;
        canvas.style.cursor = "crosshair";
      }

    },
    handleMaskImage () {
        this.isMasked=true
      let canvas = this.$refs.canvas;
      this.cropped = canvas.toDataURL()
      this.$store.commit("SHOW_NOTIFICATION", {
        showNotification: true,
        message: "Successfully Masked Image",
        succesFlag: true
      });
    },
    setCanvas () {
          this.isMasked=false;
      this.cropped = this.$store.state.ckycDetails.croppedImgUrl;
      let canvas = this.$refs.canvas;
      let context = canvas.getContext("2d");
      let image = new Image();
      image.setAttribute('crossOrigin', 'anonymous');
      image.src = this.$store.state.ckycDetails.croppedImgUrl;
      image.onload = function () {
        canvas.width = this.width
        canvas.height = this.height
        context.drawImage(image, 0, 0);
      };
    }
  },

};
</script>
<style scoped>
.b-canvas {
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.b-canvas-btn-grp {
  display: flex;
}
.b-canvas-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.b-canvas-masked-image {
  width: 358px;
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  border: solid 1px#e0e0e0;
  margin-bottom: 25px;
}
</style>
